import '@/polyfills/promiseWithResolvers'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client';
import App from './App.tsx'
import { Providers } from './Providers.tsx';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_URL,

  sendDefaultPii: true
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>
);
